//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from 'store/constants';


//  ----------------------------------------------------------------------------
//  Actions
//  ----------------------------------------------------------------------------

//  -- Create log ----------------
export const createVocabularyCongants = () => ({ type: ActionTypes.vocabularyCogantes.createVocabularyCogantes });
// export const createVocabularyFail = (returnedPayload) => ({ type: ActionTypes.vocabulary.createVocabularyFail, payload: returnedPayload });
export const createVocabularySuccessCogantes = (returnedPayload) => ({ type: ActionTypes.vocabularyCogantes.createVocabularyCogantes, payload: returnedPayload });
export const updateVocabularySuccessCogantes = (returnedPayload) => ({ type: ActionTypes.vocabularyCogantes.updateVocabularySuccessCogantes, payload: returnedPayload });

//  -- List vocabulary ----------------
export const listVocabularyCogantes = () => ({ type: ActionTypes.vocabularyCogantes.listVocabularyCogantes });
// export const listVocabularyFail = (returnedPayload) => ({ type: ActionTypes.vocabulary.listVocabularyFail, payload: returnedPayload });
export const listVocabularySuccessCogantes = (returnedPayload) => ({ type: ActionTypes.vocabularyCogantes.listVocabularySuccessCogantes, payload: returnedPayload });

// Delete vocabulary
export const deleteVocabularyCogantes = () => ({ type: ActionTypes.vocabularyCogantes.deleteVocabularyCogantes });
export const deleteVocabularySuccessCogantes = (returnedPayload) => ({ type: ActionTypes.vocabularyCogantes.deleteVocabularySuccessCogantes, payload: returnedPayload });

// Ai Cognates
export const createVocabularySuccessCogantesAI = (returnedPayload) => ({ type: ActionTypes.vocabularyCogantes.createVocabularyCogantesAI, payload: returnedPayload });
